export const SOURCE_NOT_IMPLEMENTED_EVENT = 'source-not-implemented';

const notImplemented = (label: string) => `${label} ingestion is not yet implemented.`;

export const handleOpenRssFeedDialog = () => notImplemented('RSS Feed');
export const handleMarinCountyClick = () => notImplemented('Marin County');
export const handleSonomaCountyClick = () => notImplemented('Sonoma County');
export const handleSanRafaelClick = () => notImplemented('San Rafael');
export const handleSantaRosaClick = () => notImplemented('Santa Rosa');
export const handlePetalumaClick = () => notImplemented('Petaluma');
export const handleNovatoClick = () => notImplemented('Novato');
export const handleMillValleyClick = () => notImplemented('Mill Valley');
export const handle511Click = () => notImplemented('511.org');
export const handleGoldenGateBridgeDistrictClick = () => notImplemented('Golden Gate Bridge Highway & Transportation District');
export const handleSmartClick = () => notImplemented('Sonoma Marin Area Rail Transit');
export const handleCaltransDistrict4Click = () => notImplemented('Caltrans District 4 - State Highways');
export const handleChpIncidentFeedsClick = () => notImplemented('CHP Incident Feeds');
export const handlePgeOutagesClick = () => notImplemented('PG&E - Outage Alerts & PSPS');
export const handleAlertMarinClick = () => notImplemented('AlertMarin County Emergency Alerts');
export const handleSoCoAlertClick = () => notImplemented('SoCoAlert County Emergency Alerts');
export const handleNixleClick = () => notImplemented('Nixle Community Alerts');
export const handleMarinOesPortalClick = () => notImplemented('Marin County Sheriff - OES Portal');
export const handleSoCoEmergencyClick = () => notImplemented('SoCoEmergency');
export const handleNwsBayAreaClick = () => notImplemented('National Weather Service Bay Area');
export const handleBaaqmdClick = () => notImplemented('Bay Area Air Quality Mgmt District');
export const handleMarinHhsClick = () => notImplemented('Marin County Health & Human Services (HHS) - Public Health');
export const handleSonomaDhsClick = () => notImplemented('Sonoma County Department of Health Services (DHS) - Public Health');
export const handleSonomaEdbClick = () => notImplemented('Sonoma County Economic Development Board');
